import { css } from '@emotion/react';
import { Z_INDEX } from '../../constants/zIndex';

const legendStyles = {
    legend: css({
        width: '44px',
        height: '44px',
        backgroundColor: '#ffffff',
        padding: '16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '8px',
        color: '#004FC6',
        fontSize: '18px',
        fontWeight: 600,
        cursor: 'pointer',
    }),
    menuHeader: css({
        fontSize: '15px',
        fontWeight: 600,
        margin: 0,
        textAlign: 'center',
        width: '100%',
        marginBottom: '20px',
    }),
    menuList: css({
        textAlign: 'center',
        transition: '0.3s',
        overflow: 'hidden',
        zIndex: Z_INDEX.LEGEND_DESKTOP,
        backgroundColor: '#ffffff',
        borderTopLeftRadius: 8,
        borderTopRightRadius: 8,
        width: '100%',
        padding: '10px 15px 20px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
    }),
    menuListDesktop: css({
        position: 'absolute',
        bottom: 20,
        right: 20,
        boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.1)',
        borderRadius: 8,
        width: '375px',
        padding: '8px 16px',
    }),
    legendImage: css({
        width: '100%',
    }),
};

export default legendStyles;
